import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-3 items-center w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-20 w-20 text-yellow-400",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    })
  ])
], -1)
const _hoisted_3 = { class: "flex justify-center py-2" }
const _hoisted_4 = { class: "text-xl w-full text-center font-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row justify-center w-full"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col justify-center w-full items-center"
}
const _hoisted_8 = { class: "justify-center flex flex-col pt-3 pb-2 w-2/3 mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "w-full justify-start flex flex-row font-semibold mb-3" }, " Reason: ", -1)
const _hoisted_10 = { class: "flex flex-row justify-around rounded-full py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.message), 1)
    ]),
    (_ctx.aditionalComponent === 'comment')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("textarea", {
            placeholder: "Write a reason",
            rows: "2",
            maxlength: "280",
            style: {"resize":"none"},
            class: "w-full focus:outline-none focus:ring-2 focus:ring-black text-sm text-gray-500 p-3 bg-gray-100 focus:bg-transparent rounded-2xl",
            value: _ctx.modelValue,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
          }, null, 40, _hoisted_6)
        ]))
      : (_ctx.aditionalComponent === 'select')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_v_select, {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = (e) => _ctx.$emit('update:modelValue', e)),
                options: _ctx.options,
                label: "id",
                placeholder: _ctx.placeholder
              }, null, 8, ["options", "placeholder"])
            ])
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_Button, {
        label: "Cancel",
        variant: "outlined",
        onOnClick: _ctx.closeModal
      }, null, 8, ["onOnClick"]),
      _createVNode(_component_Button, {
        label: "Confirm",
        variant: "contained",
        disabled: _ctx.aditionalComponent === 'select' && !_ctx.modelValue,
        onOnClick: _ctx.emitAction
      }, null, 8, ["disabled", "onOnClick"])
    ])
  ]))
}